var map = {
	"./#03CEA4/phoneEle.svg": "d790",
	"./#3777FF/phoneEle.svg": "bea1",
	"./#EE964B/phoneEle.svg": "9a33",
	"./#F754A2/phoneEle.svg": "a0db",
	"./#FF495C/phoneEle.svg": "efb2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fb3a";